import { render, staticRenderFns } from "./SegurMain.vue?vue&type=template&id=b56a4d80&scoped=true"
import script from "./SegurMain.vue?vue&type=script&lang=js"
export * from "./SegurMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56a4d80",
  null
  
)

export default component.exports